export default __webpack_public_path__ + "images/6d85a3cbd7ff7f2b54a7df0c59566270.svg";